import React from 'react';
import Table from 'rsuite/Table';
import Pagination from 'rsuite/Pagination';
import { RouterInput, trpc } from '../../../api/trpc';
import moment from 'moment';
import 'moment/locale/ru';
import MyLoader from '../../common/loader.component';
import useSWR from 'swr';
import { usePaginationQs } from '../../../utils/usePagination';

type SmsHistoryItem = {
  id: string;
  smsRuId: string;
  phone: string;
  text: string;
  status?: string | null;
  statusCode?: number | null;
  statusUpdatedAt?: Date | null;
  sentAt: Date;

  user: {
    id: number;
    name?: string | null;
    internalId?: number | null;
  };

  client?: {
    id: number;
    name?: string | null;
    internalId?: number | null;
  } | null;
};

export const SmsHistoryList: React.FC = () => {
  const { take, skip, handleSetPage, handleChangeLimit, page } =
    usePaginationQs(15);
  const [order, setOrder] = React.useState<'asc' | 'desc'>('desc');

  const params: RouterInput['smsRouter']['sender']['history'] = {
    take,
    skip,
    order,
  };

  const { data, error, isLoading } = useSWR(
    ['smsRouter.sender.history', params],
    async ([, args]: [string, RouterInput['smsRouter']['sender']['history']]) =>
      trpc.smsRouter.sender.history.query(args),
  );

  if (isLoading) {
    return (
      <>
        <div className="pb-4">
          <MyLoader />
        </div>
      </>
    );
  }

  if (error || !data) {
    return (
      <>
        <div className="pb-4">Неизвестная ошибка</div>
      </>
    );
  }
  return (
    <>
      <Table<SmsHistoryItem, string>
        data={data.smsList}
        autoHeight
        rowHeight={55}
        headerHeight={50}
        loading={isLoading}
      >
        <Table.Column width={100}>
          <Table.HeaderCell>ID клиента </Table.HeaderCell>
          <Table.Cell>
            {(row) => (row.client ? `${row.client.internalId ?? ''}` : '')}
          </Table.Cell>
        </Table.Column>

        <Table.Column width={150}>
          <Table.HeaderCell>Телефон</Table.HeaderCell>
          <Table.Cell>{(row) => row.phone}</Table.Cell>
        </Table.Column>

        <Table.Column flexGrow={1} fullText>
          <Table.HeaderCell>Сообщение</Table.HeaderCell>
          <Table.Cell>{(row) => row.text}</Table.Cell>
        </Table.Column>

        <Table.Column width={150}>
          <Table.HeaderCell>Ответственный</Table.HeaderCell>
          <Table.Cell>
            {(row) => (row.user ? `${row.user.name ?? ''}` : '')}
          </Table.Cell>
        </Table.Column>

        <Table.Column width={200}>
          <Table.HeaderCell>
            <button
              className="d-flex gap-1 w-100 h-100 bg-transparent"
              onClick={() =>
                setOrder((prev) => (prev === 'asc' ? 'desc' : 'asc'))
              }
            >
              Дата/Время отправки
              <i
                className={`bi ${order === 'asc' ? 'bi-sort-up' : 'bi-sort-down'}`}
              />
            </button>
          </Table.HeaderCell>
          <Table.Cell>
            {(row) => moment(row.sentAt).format('DD.MM.YYYY HH:mm')}
          </Table.Cell>
        </Table.Column>

        <Table.Column width={200} fullText>
          <Table.HeaderCell>Статус</Table.HeaderCell>
          <Table.Cell>{(row) => row.status || '-'}</Table.Cell>
        </Table.Column>
      </Table>

      {data.total > take && (
        <div className="pb-4">
          <Pagination
            prev
            next
            first
            last
            ellipsis
            boundaryLinks
            maxButtons={5}
            size="md"
            layout={['pager']}
            total={data.total}
            limit={take}
            activePage={page}
            onChangePage={handleSetPage}
            onChangeLimit={handleChangeLimit}
          />
        </div>
      )}
    </>
  );
};
